export default __webpack_public_path__ + "static/media/hamburger.a321eb5b.svg";